import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App.jsx'
import DescadastraPage from './pages/Descadastra.jsx'
import './styles/lp.css'
import './services/tracking.ts';
import {TRACKING_ENABLED} from '@/config/env'

const trackingState = TRACKING_ENABLED ? 'enabled' : 'disabled'
if (typeof document !== 'undefined') {
    document.documentElement?.setAttribute('data-tracking', trackingState)
    document
        .querySelectorAll('[data-show-when-tracking]')
        .forEach((node) => {
            const el = node
            const desired = (el.getAttribute('data-show-when-tracking') || 'true').toLowerCase()
            const showWhenTracking = !(desired === 'false' || desired === '0')
            const shouldShow = TRACKING_ENABLED ? showWhenTracking : !showWhenTracking
            if (el instanceof HTMLElement) {
                el.hidden = !shouldShow
            } else if (!shouldShow) {
                el.setAttribute('aria-hidden', 'true')
            } else {
                el.removeAttribute('aria-hidden')
            }
        })
}

// 🧠 Mostra variáveis só em dev
if (import.meta.env.DEV) {
    console.table({
        MODE: import.meta.env.MODE,
        API_BASE: import.meta.env.VITE_API_BASE_URL || '(proxy local ativo)',
        GOOGLE_META_TRACKING: TRACKING_ENABLED ? 'enabled' : 'disabled',
        DEFAULT_USUARIO_BOT_ID: import.meta.env.VITE_DEFAULT_USUARIO_BOT_ID || import.meta.env.VITE_DEFAULT_BOT_ID
    })
}

// 🔹 Normaliza path atual
const rootElement = document.getElementById('root')
const normalizePath = (pathname = '/') => {
    if (!pathname) return '/'
    const trimmed = pathname.replace(/\/+$/, '')
    return trimmed || '/'
}

const currentPath = normalizePath(window.location.pathname)
const isDescadastra = currentPath === '/descadastra'

// 🔹 Renderiza a página correspondente
createRoot(rootElement).render(isDescadastra ? <DescadastraPage/> : <App/>)
